export default {
    PENDING: 'PENDING',
    IN_PREPARATION: 'IN_PREPARATION',
    READY: 'READY',
    ON_THE_WAY: 'ON_THE_WAY',
    DELIVERED: 'DELIVERED',
    CLOSED: 'CLOSED',
    CANCELLED: 'CANCELLED',
}